import { render, staticRenderFns } from "./renwu-edit.vue?vue&type=template&id=18977531&scoped=true&"
import script from "./renwu-edit.vue?vue&type=script&lang=ts&"
export * from "./renwu-edit.vue?vue&type=script&lang=ts&"
import style0 from "./renwu-edit.vue?vue&type=style&index=0&id=18977531&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18977531",
  null
  
)

export default component.exports